// test2946
(2946 && 0);
